// A customer-scoped agent (client_id set) may only work tickets of its own customer; the backend
// refuses any other pairing (422) when the run is created, so the picker only offers agents that can
// actually be started. Global agents (no client_id) work any ticket.
export const agentsForTicket = (agents, ticketCompanyId) =>
  (agents || []).filter((agent) => !agent.client_id || agent.client_id === ticketCompanyId);

// The selection can go stale (the ticket's company changed after the agent was picked).
export const usableAgentId = (selectableAgents, selectedAgentId) =>
  selectableAgents.some((agent) => agent.id === selectedAgentId) ? selectedAgentId : "";

// The ticket's own Digital Employee binding (GET /api/tickets/{id}/employee-assignment) decides who
// starts that ticket's work when the operator has not picked another employee — otherwise assigning
// an employee is cosmetic and the run silently goes to the backend's default agent instead.
// Only an explicit `false` disables (the rule EmployeeAvatar applies to presence): an employee the
// payload marks disabled cannot work the ticket — the backend refuses that run with a 422 — so it
// falls back to the caller's own default rather than to a guaranteed refusal.
export const assignedStartAgentId = (assignment) => {
  const employee = assignment?.employee;
  if (!employee || employee.is_enabled === false) return "";
  return employee.agent_id || "";
};
